import type { HelpArticleTemplate } from "@/content/help/article-view";

export interface AuthoredKnowledgeTemplate<T = unknown> {
  id: "help-directory" | "help-contact" | "help-search" | "guide-index" | "guide-category" | "guide-article" | "static-page";
  pathname: string;
  language: "en";
  sourceReference: string;
  data: T;
}
export type PublicKnowledgeTemplate = HelpArticleTemplate | AuthoredKnowledgeTemplate;
export function knowledgeTemplate<T>(id: AuthoredKnowledgeTemplate["id"], pathname: string, data: T): AuthoredKnowledgeTemplate<T> {
  return { id, pathname, language: "en", sourceReference: `${id}:${pathname}`, data };
}
export const isKnowledgeObject = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === "object" && !Array.isArray(value);

/** Ignore a preceding navigation's packet; reject corruption in this route's
 * required view rather than silently rebuilding a different server response. */
export function seededKnowledgeData<T>(
  seed: unknown, id: AuthoredKnowledgeTemplate["id"], pathname: string,
  validate: (data: unknown) => data is T,
): T | null {
  if (!isKnowledgeObject(seed) || seed.kind !== "compiled" || !isKnowledgeObject(seed.publicTemplate)) return null;
  const packet = seed.publicTemplate;
  if (packet.pathname !== pathname) return null;
  if (packet.id !== id || packet.sourceReference !== `${id}:${pathname}` ||
      packet.language !== "en" || !validate(packet.data)) throw Error("Invalid required authored knowledge view");
  return packet.data;
}
